import { useRef } from "react";
import {
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
} from "@chakra-ui/react";
import { mutateReportsForCategory, ReportDTO } from "api/UseReports";
import { deleteReportById } from "./AdminApi";

type Props = {
    onClose: () => void;
    isOpen: boolean;
    reportToDelete: ReportDTO | null;
};

export const DeleteReportDialog = ({ onClose, isOpen, reportToDelete }: Props) => {
    const cancelRef = useRef(null);

    const handleDelete = () => {
        if (reportToDelete) {
            deleteReport(reportToDelete);
        }
    };

    const deleteReport = async (report: ReportDTO) => {
        await deleteReportById(report.id);
        mutateReportsForCategory(report.categoryId);
        onClose();
    };

    return (
        <>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Slett rapport
                        </AlertDialogHeader>

                        <AlertDialogBody>Er du sikker? Du kan ikke angre.</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Avbryt
                            </Button>
                            <Button colorScheme="red" onClick={handleDelete} ml={3}>
                                Slett
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
};
